import ACTION_TYPES from '../../constants/actionTypes';
import api from '../../api';

/**
 * Upload client CSV
 */

function uploadClientCSVRequest() {
  return {
    type: ACTION_TYPES.UPLOAD_CLIENT_CSV,
  };
}

function uploadClientCSVSuccess(longOperationId) {
  return {
    type: ACTION_TYPES.UPLOAD_CLIENT_CSV_SUCCESS,
    payload: {
      longOperationId,
    },
  };
}

function uploadClientCSVFailure(error) {
  return {
    type: ACTION_TYPES.UPLOAD_CLIENT_CSV_FAILURE,
    error,
  };
}

export function uploadClientCSV(file) {
  return (dispatch, getState) => {
    const { authToken } = getState();
    dispatch(uploadClientCSVRequest());
    return new Promise((resolve, reject) => {
      let fileApprovalId;
      api
        .awsSignFile({
          file,
          description: 'Client CSV file',
          authToken: authToken,
        })
        .then((signedFileResp) => {
          fileApprovalId = signedFileResp.file_approval_id;
          return api.awsUploadSignedFile(file, signedFileResp);
        })
        .then((uploadResp) => {
          return api.submitBulkCSVUpload(fileApprovalId, authToken);
        })
        .then((bulkCSVResp) => {
          dispatch(uploadClientCSVSuccess(bulkCSVResp.id));
          resolve(bulkCSVResp.id);
        })
        .catch((error) => {
          dispatch(uploadClientCSVFailure(error));
          reject(error);
        });
    });
  };
}

/**
 * Check CSV upload status
 */

function getCSVUploadStatusRequest() {
  return {
    type: ACTION_TYPES.GET_CSV_UPLOAD_STATUS,
  };
}

function getCSVUploadStatusSuccess(result) {
  return {
    type: ACTION_TYPES.GET_CSV_UPLOAD_STATUS_SUCCESS,
    payload: result,
  };
}

function getCSVUploadStatusFailure(error) {
  return {
    type: ACTION_TYPES.GET_CSV_UPLOAD_STATUS_FAILURE,
    error,
  };
}

function completeCSVOperation() {
  return {
    type: ACTION_TYPES.CSV_OPERATION_COMPLETE,
  };
}

export function getCSVUploadStatus() {
  return (dispatch, getState) => {
    const { authToken, bulkCSVLongOperationId } = getState();
    dispatch(getCSVUploadStatusRequest());
    return new Promise((resolve, reject) => {
      if (bulkCSVLongOperationId) {
        api
          .getLongOperationStatus(bulkCSVLongOperationId, authToken)
          .then((resp) => {
            dispatch(getCSVUploadStatusSuccess(resp));
            if (resp.done) {
              dispatch(completeCSVOperation());
            }
            resolve(resp);
          })
          .catch((error) => {
            dispatch(getCSVUploadStatusFailure(error));
            reject(error);
          });
      } else {
      }
    });
  };
}
